import { isFunction } from "./is.js";
import { hasWindow } from "./has.js";
function getRaf() {
  return hasWindow() && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout;
}
function getCancelRaf() {
  return hasWindow() && window.cancelAnimationFrame ? window.cancelAnimationFrame.bind(window) : clearTimeout;
}
function nextFrame(fn) {
  return new Promise((resolve) => {
    getRaf()(() => resolve(isFunction(fn) && fn()));
  });
}
export {
  getCancelRaf,
  getRaf,
  nextFrame
};
//# sourceMappingURL=nextFrame.js.map
